import React from 'react';

import PosDevice from '../assets/images/pos-device.png';
import { Link } from 'react-router-dom';

//import PosDevice from '../assets/images/Artboard 2.png';


function Hero() {
  return (
    <>
      <section className="py-12 px-4 md:py-16 px-2 bg-white text-center md:-mb-1" id="home">
        <div className="container mx-auto max-w-6xl">
          <h1 className="text-4xl md:text-6xl font-bold text-black mb-4">
            Revolutionize Your Business<br />
            with VernPOS Solutions
          </h1>
          <p className="text-gray-700 mb-8 text-lg">
            Innovative POS Systems and Hardware for Every Business
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
            <Link to="/products" className="border-2 border-vern text-vern hover:text-red-600 hover:border-red-200 px-8 py-3 rounded-full text-lg font-medium inline-block">
              Explore Products
            </Link>
            <Link to="/contact-us" className="bg-vern hover:bg-red-100 text-white px-8 py-3 rounded-full text-lg font-medium inline-block">
              Request a Demo
            </Link>
          </div>
          {/* Google Play Store CTA */}
          <div className="mt-10">
            <p className="text-xl font-medium text-gray-800 mb-3">Download Now</p>
            <a 
              href="https://play.google.com/store/apps/details?id=com.vernpos.posnative" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-block transition-transform hover:scale-105"
              aria-label="Download Vern POS on Google Play"
            >
              <img 
                src="https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png" 
                alt="Get Vern POS on Google Play" 
                className="h-20 w-auto md:h-24"
              />
            </a>
          </div>

        </div>
      </section>
      <div className="relative -mt-11">
        <div className="hidden lg:block absolute inset-0 bg-gradient-to-b from-white via-[#F0CECB] to-white z-0 rounded-lg" />
        <img
          src={PosDevice}
          alt="VernPOS System Display"
          className="relative z-10 rounded-lg mx-auto max-w-full h-auto"
        />
      </div>
    </>
  );
}

export default Hero;